document.addEventListener('DOMContentLoaded', function() {
  function adjustSelectWidth(select) {
    if (!select) return;
    
    const tempSelect = document.createElement('select');
    const tempOption = document.createElement('option');
    tempSelect.style.cssText = 'position:absolute;visibility:hidden;width:auto;';
    tempSelect.appendChild(tempOption);
    document.body.appendChild(tempSelect);
    
    let maxWidth = 0;
    for (let i = 0; i < select.options.length; i++) {
      tempOption.textContent = select.options[i].text;
      const width = tempSelect.offsetWidth;
      if (width > maxWidth) maxWidth = width;
    }
    
    document.body.removeChild(tempSelect);
    select.style.width = (maxWidth + 40) + 'px';
  }
  
  const sortSelect = document.getElementById('SortBy');
  if (sortSelect) {
    adjustSelectWidth(sortSelect);
  }
  
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        const newSortSelect = document.getElementById('SortBy');
        if (newSortSelect) {
          adjustSelectWidth(newSortSelect);
        }
      }
    });
  });
  
  const productGridContainer = document.getElementById('ProductGridContainer');
  if (productGridContainer) {
    observer.observe(productGridContainer.parentElement, {
      childList: true,
      subtree: true
    });
  }
});
